import React from "react";
import PluginBridge from "../index";

/**
 * Slot de itens no menu de opcoes (⋮) do ticket.
 *
 * Plugins declaram actions com `slot: "ticket-actions"` no metadata.
 * Aceita resultTypes: dialog, text, html, json.
 *
 * Props:
 *   ticketId   — id do ticket
 *   contactId  — id do contato
 *   companyId  — id da empresa (necessario para rota do plugin)
 */
export default function TicketActionsSlot({ ticketId, contactId, companyId }) {
  return (
    <PluginBridge
      slot="ticket-actions"
      as="menu-items"
      context={{ ticketId, contactId, companyId }}
    />
  );
}
